export default "__VITE_ASSET__CTjSsFh9__"